import ProjectService from '../services/project.service';
const model = JSON.parse(localStorage.getItem('project'));
const initialState = model
  ? { status: { analyzed: true }, project: model }
  : { status: { analyzed: false }, project: null };

export const project = {
  namespaced: true,
  state: initialState,
  actions: {
    analyze({ commit }, project) {
      console.log(project);
      localStorage.setItem('project',JSON.stringify(project));
      commit('analyzeProjectSuccess', project);
      // return ProjectService.analyzeProject(project).then(
      //   project => {
      //       commit('analyzeProjectSuccess', project);
      //       return Promise.resolve(project);
      //   },
      //   error => {
      //     commit('analyzeProjectFailure');
      //     return Promise.reject(error);
      //   }
      // );
    },
    deleteFile({ }, id){
      return ProjectService.deleteFile(id).then(
        response => {
          return Promise.resolve(response.data);
        },
        error => {
          return Promise.reject(response.data);
        }
      )
    },
    getReport({},data){
      console.log(`getReport ${data}`)
      return ProjectService.getReport(data.id,data.ruleType).then(
        response => {
          return Promise.resolve(response.data);
        },
        error => {
          return Promise.reject(response.data);
        }
      )
    }
  },
  mutations: {
    analyzeProjectSuccess(state, project) {
      state.status.analyzed = true;
      state.project = project;
    },
    analyzeProjectFailure(state) {
      state.status.analyzed = false;
      state.project = null;
    }
  }
};